import React from 'react';
import { translate } from 'react-multi-lang';
import { PictureOutlined, UploadOutlined } from '@ant-design/icons';
import { Upload, Button, Divider, Tooltip, Row, Col, Modal, message } from 'antd';

import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';


import { Api } from '../helpers';
//const cropper = React.createRef(null);

class ImageCropper extends React.Component {
 constructor(props){
   super(props);

   this.state = {
     img_src: null,
     desti: this.props.desti,
     guardant: false
   }
 }

   async _crop(){

      await this.setState({guardant: true});
      const dataUrl = this.cropper.getCroppedCanvas({fillColor: '#fff'}).toDataURL('image/jpeg');
      //const dataUrl = this.cropper.getCroppedCanvas().toDataURL();

      console.log("ImageCropper dataUrl: ", dataUrl);

      if(this.props.retorna_dataUrl !== undefined){
        this.setState({
          img_src: null,
          desti: null,
          previewVisible: false,
          guardant: false
        }, () =>{
          this.props.retorna_dataUrl(dataUrl);
        })
      }else{

        const url =  '/logos';
        const blob = await (await fetch(dataUrl)).blob();
        var fd = new FormData();
        fd.append("fileField", blob, "img.jpg");
        fd.append("desti", this.state.desti);

        try{

          let resposta = await Api.myFetch(url, 'POST', fd);

          if(resposta.result.success===1){
            message.success(this.props.t('generic.OK_saved'), 5);
          }else{
            message.error(resposta.data.message, 10);
          }
          await this.setState({guardant: false});
        }catch(err){
          await this.setState({guardant: false});
          console.log("Error upload: ", err);
          message.error(err, 10);
        }
      }

      if(this.props.refrescar !== undefined){
        this.props.refrescar();
      }
    }

    setAspectRatio = (ratio) => {
      this.cropper.setAspectRatio(ratio);
    }

    previewImage = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.setState({
            previewImage: reader.result,
            previewVisible: true,
            }, () =>{
              console.log(this.state);
              resolve(reader.result);
          });

        };
        reader.onerror = error => reject(error);
      });
    }

    previewImage_url = (url) => {
      this.setState({
        previewImage: url,
        previewVisible: true,
      });
    }

render(){

  return (
    <div>
    <Row justify="start">
      <Col>
        <Upload
          action={this.previewImage}
          //fileList=""
          beforeUpload={(file) => {
            console.log(file.type);
            let ok = false;
            if (file.type === 'image/png') {ok = true;}
            if (file.type === 'image/jpg') {ok = true;}
            if (file.type === 'image/jpeg') {ok = true;}
            if (file.type === 'image/gif') {ok = true;}
            if (file.type === 'image/webp') {ok = true;}
            if(!ok){
              message.error(`${file.name} is not a valid picture`);
            }
            return ok;
          }}
        >
          <Tooltip placement="bottom" title={this.props.t('generic.btn_upload_file_tooltip')} arrow={{ pointAtCenter: true }}>
            <Button>
              <UploadOutlined /> {this.props.t('generic.btn_upload_file')}
            </Button>
          </Tooltip>
        </Upload>
      </Col>

    </Row>
    {!this.state.previewVisible ? null :
      <div>
      <Divider/>
        <Cropper
          aspectRatio={1/3}
          style={{height: 400, width: '100%'}}
          guides={true}
          {...this.props}
          ref={cropper => { this.cropper = cropper; }}
          src={this.state.previewImage}
        />
        <Divider/>
        <Tooltip placement="bottom" title={this.props.t('imageCropper.btn_imageCropper')} arrow={{ pointAtCenter: true }}>
          <Button onClick={this._crop.bind(this)} loading={this.state.guardant}>
            {this.props.t('generic.modify')}
          </Button>
        </Tooltip>
      </div>
      }



    </div>
  );
}

}
export default translate(ImageCropper);
